import { useEffect } from "react";

/**
 * Auto-save / restore a form draft to localStorage. Lifesaver for the LFG
 * post, chat input, and profile bio — refresh accidentally, draft survives.
 *
 * Drafts older than 7 days are auto-discarded so stale text never resurfaces.
 *
 *   const [body, setBody] = useState("");
 *   useFormDraft("lfg-post", body, setBody);
 *
 * Pass `disabled=true` (e.g., after successful submit) to clear the draft.
 */
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

function _key(name) { return `lhub_draft:${name}`; }

export function useFormDraft(name, value, setValue, disabled = false) {
  // Restore on mount.
  useEffect(() => {
    if (disabled) return;
    try {
      const raw = localStorage.getItem(_key(name));
      if (!raw) return;
      const { v, ts } = JSON.parse(raw);
      if (Date.now() - ts > TTL_MS) {
        localStorage.removeItem(_key(name));
        return;
      }
      if (v && !value) setValue(v);
    } catch { /* ignore */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);

  // Persist on every value change.
  useEffect(() => {
    if (disabled) { try { localStorage.removeItem(_key(name)); } catch {} return; }
    try {
      if (value) localStorage.setItem(_key(name), JSON.stringify({ v: value, ts: Date.now() }));
      else localStorage.removeItem(_key(name));
    } catch { /* ignore */ }
  }, [name, value, disabled]);
}

export function clearFormDraft(name) {
  try { localStorage.removeItem(_key(name)); } catch { /* ignore */ }
}
